import React from 'react'
import { Button, Typography } from '@mui/material'
import { useDialog } from 'components/DialogV3'
import { useTranslation } from 'react-i18next'
import DialogContactUs from './DialogContactUs'

const FooterAuthentication = () => {
    const { t } = useTranslation()
    const { openDialog } = useDialog()

    const handleOpenDialogContactUs = () => {
        openDialog(DialogContactUs)
    }

    return (
        <div className="footer-login">
            <Button id='btn-open-dialog-contact-us' variant='text' onClick={handleOpenDialogContactUs}>{t('actions.contactUs')}</Button>
            <Typography>{t('viettel.managing')}</Typography>
            <Typography>{t('viettel.date')}</Typography>
        </div>
    )
}

export default FooterAuthentication